import { useCallback } from 'react'

import { sendGa4EventToGtm } from '@infrastructure/GoogleTagManager'
import { WindowLocation } from '@reach/router'

export const useVirtualPageViewGa4Event = (location: WindowLocation<unknown>): (() => void) => {
    const url = `${location.pathname}${location.search}`

    return useCallback(() => {
        sendGa4EventToGtm({
            event_name: 'virtualPageview',
            page_path: url,
            page_title: document.title,
            event: 'ga4Event',
        })
    }, [url])
}
